import { MENU_KEY_ROUTES } from "src/constants/modules";
import { PointsExchangeListing, ProgramExchange } from "src/Modules/PointsExchange";

export const pointsExchangeRoutes = {
  path: MENU_KEY_ROUTES["Loyalty"],
  children: [
    {
      index: true,
      element: <PointsExchangeListing/>
    },
    {
      path:"exchange-points/:code",
      element:<ProgramExchange/>
    }
  ],
};
